import { useState, useCallback } from "react"
import { getSegmentDeviceId } from "@mindbodygreen/analytics-tracking-helpers"
import { identifyUser } from "utils/identifyUser"
import { navigate } from "gatsby"

const useContactZendesk = (trackingId) => {
  const [contacting, setContacting] = useState(false)
  const [contacted, setContacted] = useState(false)
  const [zendeskError, setZendeskError] = useState(false)

  const contactZendesk = useCallback(
    async (data, redirect) => {
      setContacting(true)

      const { firstName, lastName } = data

      try {
        const response = await fetch(`/api/contact`, {
          method: `POST`,
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify(data),
        })
        const userData = await response.json()

        if (userData) {
          const { user } = userData
          try {
            await identifyUser({ user, firstName, lastName })
          } catch (error) {
            console.log(error)
          }
        }

        if (!response.ok) {
          setZendeskError(true)
        } else {
          if (window.analytics) {
            // tracking only if successful
            const trackingProps = {
              element_id: trackingId,
            }
            window.analytics.track("Contact Form Submitted", trackingProps, {
              device: { id: getSegmentDeviceId() },
            })
          }

          setContacted(true)
        }

        if (redirect) navigate(redirect)
      } catch (err) {
        setZendeskError(true)
        console.error(err)
      }

      setContacting(false)
    },
    [trackingId],
  )

  const onClosePopup = () => {
    setContacted(false)
    setContacting(false)
    setZendeskError(false)
  }

  return { contacting, contacted, zendeskError, contactZendesk, onClosePopup }
}

export default useContactZendesk
